const root = "_root_oglih_1";
const inputField = "_input-field_oglih_16";
const ctaDisclaimer = "_cta-disclaimer_oglih_30";
const styles = {
	root: root,
	inputField: inputField,
	ctaDisclaimer: ctaDisclaimer
};

export { styles as s };
//# sourceMappingURL=SubscriptionForm.module-BPLbtSf-.mjs.map
